module.exports = __webpack_public_path__ + "img/us.68a3bd51.svg";